import { createFileRoute } from "@tanstack/react-router";
import { Layout } from "@/components/layout/Layout";
import { ArticleTranslationProvider } from "@/context/ArticleTranslationContext";

export const Route = createFileRoute("/_app")({
  component: AppLayout,
});

function AppLayout() {
  return (
    <ArticleTranslationProvider>
      <Layout />
    </ArticleTranslationProvider>
  );
}
